import { allRoles, isAuthorized, lazyLoadView } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'

export const pluginsRoutes: RouteConfig[] = [
  {
    path: 'ui-i18n',
    name: 'ui-i18n',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitI18nView.vue')),
    meta: {
      title: 'I18n',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-i18n',
    },
  },
  {
    path: 'ui-nds-toast',
    name: 'ui-nds-toast',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitNdsToastView.vue')),
    meta: {
      title: 'Toast plugin',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-nds-toast',
    },
  },
  {
    path: 'ui-event-bus',
    name: 'ui-event-bus',
    component: () => lazyLoadView(import('@/ui-kit/views/plugins/UiKitEventBusView.vue')),
    meta: {
      title: 'EventBus',
      is_authorized: (route: Route) => isAuthorized(route),
      requires_auth: true,
      requires_tenant: true,
      requires_role: allRoles,
      doc_id: 'ui-event-bus',
    },
  },
]
